/**
 * @generated SignedSource<<9c8b59926f4b46d43bbe5e952f81da34>>
 * @relayHash b6c96ca7d0b8f5ad11cc6ec5c8a3b171
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 898107f14cb141796b4e634698cfa63c8920a1321515e8bd0436ef327a0ed29d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PopupContentQuery } from './PopupContentQuery.graphql';

const node: PreloadableConcreteRequest<PopupContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "898107f14cb141796b4e634698cfa63c8920a1321515e8bd0436ef327a0ed29d",
    "metadata": {},
    "name": "PopupContentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
